const Required = ({ children }) => (
  <span className="required-field">{children}</span>
);

export default Required;